import { render, staticRenderFns } from "./AnimatedLoader.vue?vue&type=template&id=6e5db052&scoped=true"
import script from "./AnimatedLoader.vue?vue&type=script&lang=js"
export * from "./AnimatedLoader.vue?vue&type=script&lang=js"
import style0 from "./AnimatedLoader.vue?vue&type=style&index=0&id=6e5db052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5db052",
  null
  
)

export default component.exports